// Slick init moved to assets/slick-init.js (loaded only on product templates).
// This file is jQuery-free and loads on every page.

document.querySelectorAll('.ctm_country .disclosure__button').forEach(button => {
  button.addEventListener('click', (e) => {
    e.stopPropagation();
    let parent = button.closest('.disclosure');

    document.querySelectorAll('.disclosure.active').forEach(el => {
      if (el !== parent) {
        el.classList.remove('active');
      }
    });

    parent.classList.toggle('active');
  });
});


document.addEventListener('click', () => {
  document.querySelectorAll('.disclosure.active').forEach(el => {
    el.classList.remove('active');
  });
});


document.querySelectorAll('.ctm_collection_btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const card = btn.closest('.card');
    if (!card) return;

    const quickAddBtns = card.querySelectorAll('.ctm_prd_price .quick-add__submit');

    quickAddBtns.forEach(qBtn => {
      qBtn.click();
    });
  });
});




document.querySelectorAll('.banner').forEach(banner => {
  banner.addEventListener('click', () => {
    const btn = banner.querySelector('.banner__buttons a');
    if (btn) {
      btn.click();
    }
  });
});


document.querySelectorAll('.ctm_card_anchor').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    let siblingAnchor = this.previousElementSibling;

    if (siblingAnchor && siblingAnchor.tagName.toLowerCase() === 'a') {
      siblingAnchor.click();
    }
  });
});




document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ctm_collection_prd_btn").forEach(btn => {
    btn.addEventListener("click", function () {
      let productId = btn.getAttribute("data-prdid");
      if (!productId) return;

      // Cart add request
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: 1
        })
      })
        .then(res => res.json())
        .then(data => {
          window.location.href = '/cart';
        })
        .catch(err => console.error('Error:', err));
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  let rawHash = window.location.hash.substring(1);

  let collectionName = rawHash ? decodeURIComponent(rawHash) : "Best Sellers";

  let collectionSlug = collectionName
    .toLowerCase()
    .replace(/[%\s#]+/g, "-")
    .replace(/[^a-z0-9-]/g, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

  let newUrl = `/collections/${collectionSlug}`;

  let anchor = document.querySelector(".ctm_coll_bread a");

  if (anchor) {
    anchor.href = newUrl;
    anchor.textContent = collectionName;
  }
});


// ========== Used In Top-Rated Section

if (!customElements.get('collection-cards-container')) {
  customElements.define('collection-cards-container', class extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.mobileBreakpoint = window.matchMedia('(max-width: 749px)');
      this.isCarouselEnabled = this.dataset.mobileCarousel === 'true';
      this.wrapper = this.querySelector('.swiper-wrapper');
      this.gridClasses = ['!tw-grid', 'tw-grid-cols-4', 'max-md:!tw-grid-cols-2', 'tw-gap-[20px]', 'max-md:!tw-gap-x-[14px]', 'max-md:!tw-gap-y-[18px]'];
    }

    connectedCallback() {
      if (!this.isCarouselEnabled) {
        this.applyGrid();
        return;
      }

      this.mobileBreakpoint.addEventListener('change', () => this.handleLayout());
      this.handleLayout();
    }

    handleLayout() {
      if (this.mobileBreakpoint.matches) {
        this.initSwiper();
      } else {
        this.destroySwiper();
      }
    }

    initSwiper() {
      if (this.swiperInstance || !this.isCarouselEnabled) return;

      this.wrapper.classList.remove(...this.gridClasses);
      this.wrapper.style.display = 'flex';

      this.swiperInstance = new Swiper(this, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        pagination: {
          el: this.querySelector('.swiper-pagination-mobile'),
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.swiper-btn-next-mobile'),
          prevEl: this.querySelector('.swiper-btn-prev-mobile'),
        },
        breakpoints: {
          480: { slidesPerView: 2.2 }
        }
      });
    }

    destroySwiper() {
      if (this.swiperInstance) {
        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      }
      this.applyGrid();
    }

    applyGrid() {
      this.wrapper.style.display = '';
      this.wrapper.classList.add(...this.gridClasses);
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  let selectedInput = document.querySelector('.variant-option-list input[type="radio"]:checked');
  let selectedValue = document.querySelector('.selected-option-value');

  if (selectedInput && selectedValue) {
    selectedValue.textContent = selectedInput.value;
  }
});
$('.product-variant-option-label').on('click', function () {
    var variantprice = $(this).attr('variant-price');

    $('.atc-price').text('- ' + variantprice);
});


$(document).on('click', 'a[title="Return Policy"]', function (e) {
  e.preventDefault();

  var $target = $('.faq-sec').last();
  if (!$target.length) return;

  var el = $target[0];
  var lastTop = null;
  var stableCount = 0;
  var checks = 0;
  var maxChecks = 40; // ~4s safety cap in case something never settles

  function currentTop() {
    return el.getBoundingClientRect().top + window.pageYOffset - 100;
  }

  function tick() {
    checks++;
    var top = currentTop();

    if (lastTop === null || Math.abs(top - lastTop) > 2) {
      // target moved (images/swiper/iframe still loading above it) — re-aim
      window.scrollTo({ top: top, behavior: checks === 1 ? 'smooth' : 'auto' });
      stableCount = 0;
    } else {
      stableCount++;
    }

    lastTop = top;

    if (stableCount < 3 && checks < maxChecks) {
      setTimeout(tick, 100);
    }
  }

  tick();
});




$(document).on('click', 'a[title="Return Policy"]', function (e) {
  e.preventDefault();
  var $target = $('.faq-sec:visible').last();
  if (!$target.length) return;
  var el = $target[0];

  function startPolling() {
    var lastTop = null;
    var stableCount = 0;
    var checks = 0;
    var maxChecks = 60; // ~6s safety cap
    var requiredStable = 5; // was 3 — a bit more tolerant of late shifts

    function currentTop() {
      return el.getBoundingClientRect().top + window.pageYOffset - 100;
    }

    function tick() {
      checks++;
      var top = currentTop();
      if (lastTop === null || Math.abs(top - lastTop) > 2) {
        window.scrollTo({ top: top, behavior: checks === 1 ? 'smooth' : 'auto' });
        stableCount = 0;
      } else {
        stableCount++;
      }
      lastTop = top;
      if (stableCount < requiredStable && checks < maxChecks) {
        setTimeout(tick, 100);
      }
    }
    tick();
  }

  // Wait for images inside/above the target to finish loading first,
  // so we don't lock onto a pre-layout-shift position.
  var $imgs = $('img').filter(function () {
    return !this.complete;
  });

  if ($imgs.length) {
    var remaining = $imgs.length;
    $imgs.one('load error', function () {
      remaining--;
      if (remaining <= 0) startPolling();
    });
    // safety fallback in case some image never fires
    setTimeout(startPolling, 1500);
  } else {
    startPolling();
  }
});


// $(document).on('click', 'a[title="Return Policy"], a[title="refund"]', function (e) {
//   e.preventDefault();

//   var targetId = $(this).attr('href');

//   if (!targetId || targetId === '#') return;

//   var $target = $(targetId);

//   if (!$target.length) return;

//   $('html, body').stop().animate({
//     scrollTop: $target.offset().top - 100
//   }, 800);
// });
// $(document).on("click", 'a[title="Return Policy"]', function(e) {
// e.preventDefault();

// var targetId = $(this).attr('href');
//   var $target = $(targetId);

//   if (!$target.length) return;

//   $('html, body').animate({
//     scrollTop: $target.offset().top - 100
//   }, 800);
// });

// $(document).on('click', 'a[title="refund"]', function(e) {
//   e.preventDefault();

//   var targetId = $(this).attr('href');
//   var $target = $(targetId);

//   if (!$target.length) return;

//   $('html, body').animate({
//     scrollTop: $target.offset().top - 100
//   }, 800);
// });

// $(document).on('click', '.add-to-cart', function () {
//   var productid = $(this).attr('data-variant-id');
//   console.log(productid);
//   $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: {
//       quantity: 1,
//       id: productid
//     },
//     dataType: 'json',
//     success: function(data){ 

//       $.ajax({
//         type: 'GET',
//         url: '/cart.js',
//         dataType: 'json',

//         success: function(data){
//               $('cart-count-bubble').html($(data).find('cart-count-bubble').html());
//           // drawer open
//           $('cart-drawer').addClass('active');
//           $('cart-drawer').removeClass('is-empty');
//           // drawer content update
//           $.ajax({
//             type: 'GET',
//             url: '/cart',

//             success: function(data){

//               $('.cart-drawer').html(
//                 $(data).find('.cart-drawer').html()
//               );

//             }

//           });

//         }

//       });

//     }

//   });

// });


document.addEventListener('click', async function (event) {
  const button = event.target.closest('.ctm-atc');
  if (!button) return;

  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  const originalText = button.innerText;
  button.innerText = 'Adding...';

  try {
    // 1. Add item and request Shopify to re-render the cart drawer & header sections simultaneously
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        // This tells Shopify to fetch updated HTML for your cart drawer and cart icon bubble
        sections: ['cart-drawer', 'cart-icon-bubble']
      })
    });

    const data = await response.json();

    if (response.ok) {
      button.innerText = 'Added!';

      // 2. Inject the newly rendered sections back into the DOM dynamically
      if (data.sections) {
        // Update cart drawer html
        if (data.sections['cart-drawer']) {
          const parser = new DOMParser();
          const parsedDrawer = parser.parseFromString(data.sections['cart-drawer'], 'text/html');
          const newDrawerContent = parsedDrawer.querySelector('cart-drawer') || parsedDrawer.getElementById('CartDrawer');
          const currentDrawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
          
          if (newDrawerContent && currentDrawer) {
            currentDrawer.innerHTML = newDrawerContent.innerHTML;
          }
        }

        // Update header cart count bubble
        if (data.sections['cart-icon-bubble']) {
          const parser = new DOMParser();
          const parsedBubble = parser.parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const newBubbleContent = parsedBubble.getElementById('cart-icon-bubble');
          const currentBubble = document.getElementById('cart-icon-bubble');
          
          if (newBubbleContent && currentBubble) {
            currentBubble.replaceWith(newBubbleContent);
          }
        }
      }

      // 3. Force open the cart drawer component natively
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        // Fallback generic class toggles used by various themes
        document.documentElement.classList.add('js-drawer-open', 'cart-drawer-open');
        const drawerElement = document.getElementById('CartDrawer') || document.querySelector('.cart-drawer');
        if (drawerElement) drawerElement.classList.add('active', 'is-open');
      }

      // 4. Dispatch standard theme update events
      document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
      if (typeof window.PubSub !== 'undefined' && typeof window.PubSub.publish === 'function') {
        window.PubSub.publish('cart-update', data);
      }

    } else {
      button.innerText = 'Error';
      console.error('Failed to add to cart:', data.message || data.description);
    }
  } catch (error) {
    button.innerText = 'Error';
    console.error('Error:', error);
  }

  setTimeout(() => {
    button.innerText = originalText;
  }, 2000);
});

// $(document).on('click', '[data-preorder-option]', function () {
//     var value = $(this).attr('data-preorder-option');

//     setTimeout(function () {
//         $('.product-form__submit span:first').text(value);
//     }, 500);
// });
